<div class="change-page-buttons">
  <button class="previous-page" (click)="getPreviousPage()" [disabled]="atFirstPage || blockButton">
    <i class="uil uil-arrow-left"></i>
  </button>
  <p>{{ getPaginationString(currentPage, pageCount) }}</p>
  <button class="next-page" (click)="getNextPage()" [disabled]="atLastPage || blockButton">
    <i class="uil uil-arrow-right"></i>
  </button>
</div> 